








import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component
export default class NotFound extends Vue {}
